<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      title="生成对账单"
      :data="data"
      :form-rules="rules"
      :save-func="()=>{}"
      @edit-opened="onEditOpened"
    >
      <template slot="form">
        <el-form-item label="对账月份" prop="StartDate">
          <el-date-picker
            v-model="data.StartDate"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份"
            @change="onChange"
          />
        </el-form-item>
        <el-form-item label="对账月份">
          <div v-if="data.StartDate">
            <span>{{$commonJs.toDateString(MountStart)}}</span>
            <span style="margin: 5px;">至</span>
            <span>{{$commonJs.toDateString(MountEnd)}}</span>
          </div>
        </el-form-item>
        <el-form-item label="人员类别" prop="MemberType">
          <el-select v-model="data.MemberType" placeholder="请选择人员类别">
            <el-option label="学生" :value="0"></el-option>
            <el-option label="教职人员" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="save">生 成</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        StartDate: null,
        MemberType: null,
      },
      MountStart: "",
      MountEnd: "",
      isMB: this.$store.state.isMB,
      api: require("@/api/cp/bill").default,
      rules: {
        StartDate: [{ required: true, message: "对账月份不能为空" }],
        MemberType: [{ required: true, message: "人员类型不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onEditOpened(data) {},
    onChange() {
      var now_date = new Date(this.data.StartDate);
      var start = this.$dayjs(now_date).startOf("month").$d;
      this.MountStart = start;
      var end = this.$dayjs(now_date).endOf("month").$d;
      this.MountEnd = end;
    },
    save() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;
        this.$refs.dialog.isLoading = true;
        this.api
          .build(this.data.StartDate, this.data.MemberType)
          .then((res) => {
            this.$refs.dialog.isLoading = false;
            if (res.Code == 0) {
              this.$message.success("生成成功");
              this.$emit("close-saved");
              this.close(true);
            } else {
              this.$message.error(res.Msg);
            }
          });
      });
    },
  },
};
</script>